import { Sparkles, Target, ListChecks, FileText } from 'lucide-react';

/**
 * Get step header information (icon, title, subtitle, iconColor) based on current step
 * @param {number} currentStep - The current step number (1-4)
 * @param {boolean} importMode - Whether we're in import mode
 * @param {Function} t - Translation function from react-i18next
 * @returns {Object} Step header configuration with icon, title, subtitle, and iconColor
 */
export function getStepHeaderInfo(currentStep, importMode = false, t) {
  const stepConfigs = {
    1: {
      icon: Sparkles,
      title: importMode ? t('step1.enhanceCourseInfo') : t('step1.tellAboutCourse'),
      subtitle: importMode ? t('step1.workWithCoby') : t('step1.chatToGetStarted'),
      iconColor: 'text-orange-500'
    },
    2: {
      icon: Target,
      title: importMode ? t('step2.defineObjectives') : t('step2.defineObjectives'), // Import mode uses same translation key
      subtitle: importMode ? t('step2.whatShouldStudentsDo') : t('step2.whatShouldStudentsDo'),
      iconColor: 'text-teal-500'
    },
    3: {
      icon: ListChecks,
      title: importMode ? t('step3.designActivities') : t('step3.designActivities'), // Import mode uses same translation key
      subtitle: importMode ? t('step3.createStructured') : t('step3.createStructured'),
      iconColor: 'text-pink-500'
    },
    4: {
      icon: FileText,
      title: t('step4.courseOverview'),
      subtitle: '', // Step 4 doesn't have a subtitle in the main header
      iconColor: 'text-teal-500'
    }
  };

  return stepConfigs[currentStep] || stepConfigs[1];
}
